import { defineComponent as _defineComponent } from 'vue'
import { inject } from 'vue';
import { useRouter } from 'vue-router/composables';

import { NavBar, HelperViewStatus } from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';


export default /*#__PURE__*/_defineComponent({
  __name: 'HandleError',
  setup(__props) {

const router = useRouter();

const fetchInitialData = inject('fetchInitialData', () => ({}));

function handleBack() {
  router.push({ name: 'trade' });
}

return { __sfc: true,router, fetchInitialData, handleBack, NavBar, HelperViewStatus, BackButton }
}

})